
type StepperHeader ={
    title:string
}

export const StepperDatesHeader = ({title}: StepperHeader)=>{

    return (
     <div className="w-100 dates-header">
        <p className="txt-uppercase p-0 m-0 p-2">{title}</p>
     </div>
    )
    
    }